import { render, staticRenderFns } from "./file-table.vue?vue&type=template&id=3a30ea08&scoped=true&"
import script from "./file-table.vue?vue&type=script&lang=js&"
export * from "./file-table.vue?vue&type=script&lang=js&"
import style0 from "./file-table.vue?vue&type=style&index=0&id=3a30ea08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30ea08",
  null
  
)

export default component.exports